import cc from 'classcat';
import React from 'react';

type Props = {
  id?: string;
  active: boolean;
  icon: React.ReactNode;
  text: string;
  onToggleClick?: () => void;
};

const OverlayTabToggle: React.FC<Props> = (props: Props) => {
  const { active, onToggleClick, icon, text, id } = props;

  function handleToggleClick() {
    if (onToggleClick) {
      onToggleClick();
    }
  }

  return (
    <button
      id={id}
      className={cc([
        `flex items-center h100 mr4 b-none bgd-white-2 p0`,
        { 'black-2': !active },
        { 'primary-blue': active },
        { 'cursor-pointer': onToggleClick },
      ])}
      style={{ outline: 'none' }}
      onClick={handleToggleClick}
    >
      <div
        className="flex-center mr1"
        style={{ width: '24px', height: '24px' }}
      >
        {icon}
      </div>
      <div>{text}</div>
    </button>
  );
};

export default OverlayTabToggle;
